<template>
  <div v-show="show==undefined||show==0||show==''" class="appdownload code_img">
    <div @click="closeAppDownload()" class="closeAppdownload">
      <a href="javascript:;">X</a>
    </div>
    <div>下载邱显峰整体瑜伽APP</div>
    <div class="appdownload-div">
      <img
        src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/%E8%92%B2%E5%85%AC%E8%8B%B1%E5%AE%89%E5%8D%93.png"
      />
      <span>Android端</span>
      <img
        src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/khyoga/%E8%92%B2%E5%85%AC%E8%8B%B1%E5%AE%89%E5%8D%93.png"
      />
      <span>IOS端</span>
    </div>
    <div>
      <p>手机扫码下载APP</p>
      <p>注册即可在APP内报名</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: 0
    };
  },
  props: ["name"],
  methods: {
    closeAppDownload: function() {
      this.show = 1;
      sessionStorage.setItem("do_not_show", 1);
    }
  },
  mounted() {
    this.show = sessionStorage.getItem("do_not_show");
  }
};
</script>

<style>
.code_img {
  /* border:1px solid red; */
  /* width: 180px; */
}
</style>


// WEBPACK FOOTER //
// src/components/Appdowload.vue